import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "@/lib/attribution";

const MEASUREMENT_ID = "G-7R2MFQ81WN";

/**
 * Tracks page views in Google Analytics and Meta Pixel on every client-side route change.
 * The gtag and fbq scripts themselves are loaded in index.html.
 * Both respect the consent state managed by CookieBanner.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Private journeys (organizer portal) must never be tracked.
    if (location.pathname.startsWith("/espace-mariage") || location.pathname.startsWith("/espace-reception")) return;
    // Capture UTM / referrer once per session for source attribution on form submits.
    captureAttribution();
    // Google Analytics 4 page view
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
        send_to: MEASUREMENT_ID,
      });
    }
    // Meta Pixel page view (only fires if consent was granted via fbq('consent','grant'))
    if (typeof window.fbq === "function") {
      try { window.fbq("track", "PageView"); } catch (_) { /* noop */ }
    }
  }, [location.pathname, location.search]);

  return null;
}
